import { isRepeatedGrain } from './column-grain'

const ALL = ['sum', 'avg', 'count', 'min', 'max', 'distinct_count']
const COUNTS = ['count', 'distinct_count']

// Aggregations a column may take, default first (options[0] is what the chart card picks).
// `role` and `default_aggregation` come resolved from the API; never re-derive them here.
export const aggregationOptions = (column) => {
  if (!column) return COUNTS
  if (column.is_row_id) return ['count']
  if (column.role && column.role !== 'measure') return COUNTS
  // A repeated value: sum over-counts and avg is row-weighted; min/max/distinct_count are exact.
  if (isRepeatedGrain(column)) return ['distinct_count', 'min', 'max', 'count']

  if (column.role === 'measure') {
    const first = column.default_aggregation || 'sum'
    return [first, ...ALL.filter((a) => a !== first)]
  }

  const numeric =
    ['min_max', 'greater_than'].includes(column.filter_type) ||
    ['money', 'two_digit_money'].includes(column.display_as)
  return numeric ? ['sum', 'count', 'avg', 'min', 'max', 'distinct_count'] : COUNTS
}

// The row-identity column (a plain count) first, then every measure.
export const measureColumns = (columns) => {
  const all = columns || []
  return [...all.filter((c) => c.is_row_id), ...all.filter((c) => c.role === 'measure' && !c.is_row_id)]
}

// The section's primary amount when it has one; else the row count, as the card always defaulted
// to; else the first measure.
export const defaultMeasureColumn = (columns) => {
  const measures = measureColumns(columns)
  return measures.find((c) => c.is_primary_amount) || measures.find((c) => c.is_row_id) || measures[0]
}
